const middleware = {}

middleware['asset-signing'] = require('../middleware/asset-signing.js')
middleware['asset-signing'] = middleware['asset-signing'].default || middleware['asset-signing']

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['redirect-to-folio'] = require('../middleware/redirect-to-folio.js')
middleware['redirect-to-folio'] = middleware['redirect-to-folio'].default || middleware['redirect-to-folio']

middleware['x-frame-options'] = require('../middleware/x-frame-options.js')
middleware['x-frame-options'] = middleware['x-frame-options'].default || middleware['x-frame-options']

export default middleware
